import React from "react";
import Landing from "views/Landing/Landing";
import { withRouter } from "react-router-dom";

const AgentDashboard = (props) => {
  return <Landing isSourceSWIM={false}/>
};

export default withRouter(AgentDashboard);
